import {
  SiReact,
  SiRedux,
  SiNodedotjs,
  SiExpress,
  SiPostgresql,
  SiSequelize,
  SiTailwindcss,
  SiNextdotjs
} from 'react-icons/si'

export const ICONS_BY_TECH = [
  {
    name: 'React',
    icon: <SiReact />
  },
  {
    name: 'Redux',
    icon: <SiRedux />
  },
  {
    name: 'NodeJs',
    icon: <SiNodedotjs />
  },
  {
    name: 'Express',
    icon: <SiExpress />
  },
  {
    name: 'PostgreSQL',
    icon: <SiPostgresql />
  },
  {
    name: 'Sequelize',
    icon: <SiSequelize />
  },
  {
    name: 'TailwindCSS',
    icon: <SiTailwindcss />
  },
  {
    name: 'NextJs',
    icon: <SiNextdotjs />
  }
]